import { useState } from "react"
import { useTranslation } from "react-i18next"
import Button from "@mui/material/Button"
import AddIcon from "@mui/icons-material/Add"

import type { DeviceWGroupsNStatesNStatus } from "types/device.types"

import AddDevicesToGroupPopup from "widgets/deviceGroups/editor/AddDevicesToGroupPopup"

interface DevicesTableToolbarProps {
  devices: DeviceWGroupsNStatesNStatus[]
}

const DevicesTableToolbar = ({ devices }: DevicesTableToolbarProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      <Button
        size="small"
        onClick={handleClick}
        startIcon={<AddIcon />}
        sx={{ fontSize: "0.75rem" }}
      >
        {t("device_groups.ADD_DEVICE")}
      </Button>
      {open && (
        <AddDevicesToGroupPopup
          onClose={handleClose}
          open={open}
          groupDevices={devices}
        />
      )}
    </>
  )
}

export default DevicesTableToolbar
